/* ═══════════════════════════════════════════════════
   TrackLab v2 — Countdown Timer
   ═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  TL.countdown = {};
  var lastPollTrigger = 0; // throttle: at most one poll trigger per 10s

  TL.countdown.update = function () {
    var now = Date.now();
    var needsPoll = false;
    document.querySelectorAll('.v2-page .cd-time[data-race-start]').forEach(function (el) {
      var start = new Date(el.dataset.raceStart).getTime();
      var duration = parseInt(el.dataset.duration) || 0;
      var diff = start - now;
      var isInBanner = !!el.closest('.live-banner');

      if (diff > 0) {
        // Upcoming: show time until start
        var mins = Math.floor(diff / 60000);
        var secs = Math.floor((diff % 60000) / 1000);
        if (mins >= 60) {
          var h = Math.floor(mins / 60);
          el.textContent = h + 'h ' + (mins % 60) + 'm';
        } else {
          el.textContent = mins + ':' + (secs < 10 ? '0' : '') + secs;
        }
        el.classList.remove('pulsing');
        // Trigger immediate schedule poll when countdown just crossed 0
        if (diff < 1000) needsPoll = true;
      } else if (isInBanner && duration > 0) {
        // Live banner: use off_dt when available, otherwise estimate
        // from scheduled_start + 30s walk-to-post
        var banner = el.closest('.live-banner');
        var offTime = banner && banner.dataset.offTime;
        var raceStartedAt;
        if (offTime) {
          raceStartedAt = new Date(offTime).getTime();
        } else {
          raceStartedAt = start + 30000; // assume 30s walk-to-post
        }
        var raceElapsed = (now - raceStartedAt) / 1000;
        if (raceElapsed < 0) {
          // Still in walk-to-post phase
          el.textContent = window.innerWidth <= 700 ? 'Starting' : 'Heading to start';
        } else {
          var remaining = Math.max(0, duration - raceElapsed);
          var m = Math.floor(remaining / 60);
          var s = Math.floor(remaining % 60);
          el.textContent = m + ':' + (s < 10 ? '0' : '') + s;
          if (remaining <= 0) {
            el.textContent = 'Finishing';
          }
        }
        el.classList.add('pulsing');
      } else if (!isInBanner) {
        // Race row: show "Race starting..." once countdown passes 0
        el.textContent = 'Race starting\u2026';
        el.classList.add('pulsing');
        needsPoll = true;
      }
    });
    // Trigger immediate schedule poll so promotion happens without waiting 30s
    // Throttle to at most once per 10s to avoid hammering the server
    if (needsPoll && TL.schedule && TL.schedule.poll) {
      var now2 = Date.now();
      if (now2 - lastPollTrigger > 10000) {
        lastPollTrigger = now2;
        TL.schedule.poll();
      }
    }
  };

  /**
   * Format a countdown diff (ms) into a display string.
   * Exported for testing.
   */
  TL.countdown._formatDiff = function (diff) {
    if (diff <= 0) return null;
    var mins = Math.floor(diff / 60000);
    var secs = Math.floor((diff % 60000) / 1000);
    if (mins >= 60) {
      var h = Math.floor(mins / 60);
      return h + 'h ' + (mins % 60) + 'm';
    }
    return mins + ':' + (secs < 10 ? '0' : '') + secs;
  };

  /**
   * Format remaining race time (seconds) into a display string.
   * Exported for testing.
   */
  TL.countdown._formatRemaining = function (remaining) {
    if (remaining <= 0) return 'Finishing';
    var m = Math.floor(remaining / 60);
    var s = Math.floor(remaining % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  };

  // Start ticking
  setInterval(TL.countdown.update, 1000);
})();
